import { render, staticRenderFns } from "./artistMergeLogDetail.vue?vue&type=template&id=8933aa14&scoped=true"
import script from "./artistMergeLogDetail.vue?vue&type=script&lang=js"
export * from "./artistMergeLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8933aa14",
  null
  
)

export default component.exports